import Head from 'next/head';

const MY_STIHL_HEAD_TITLE = '– MY STIHL – STIHL';

export const HeadTitle = ({ title }) => {
  return (
    <Head key="title">
      <title>{`${title} ${MY_STIHL_HEAD_TITLE}`}</title>;
    </Head>
  );
};
